export class GuruCharacteristic {

  entityName!: string;
  propertyName!: string;
  value!: string;

}
